import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LottieModule } from 'ngx-lottie';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';
import { TranslateModule } from '@ngx-translate/core';
import { ToastBody } from 'src/app/core/models/notification.model';

@Component({
    selector: 'app-toast',
    standalone: true,
    imports: [CommonModule, LottieModule, TranslateModule],
    template: `
        <div class="toast fade-right-animation show border-0">
            <div class="toast-header">
                <button type="button" aria-label="close" class="btn-close" data-bs-dismiss="toast"></button>
            </div>
            <div class="position-relative py-2 ps-1" [ngClass]="toastClass">
                <div class="d-flex align-items-center">
                    <span class="me-2 toast-message-lottie">
                        <ng-lottie [options]="{ path: toastImage, loop: false }" width="100%" height="100%"></ng-lottie>
                    </span>
                    <span>
                        {{ toastBody.toastMessage | translate }}
                    </span>
                </div>
            </div>
        </div>
    `,
    styleUrls: ['./toast.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToastComponent extends Toast implements OnInit {
    toastBody: ToastBody = { toastType: '', toastMessage: '' };

    constructor(protected toast: ToastrService, public toastPackage: ToastPackage) {
        super(toast, toastPackage);
    }

    ngOnInit(): void {
        this.toastBody.toastType = this.toastPackage.toastType ? this.toastPackage.toastType : '';
        this.toastBody.toastMessage = this.toastPackage.message ? this.toastPackage.message : '';
        this.toastBody.toastTitle = this.toastPackage.title;
    }

    // Returns the toast body class based on toast type
    get toastClass(): string {
        let assignedClass: string = '';
        if (this.toastBody?.toastType.toLowerCase() === 'success') {
            assignedClass = 'toast-body-success';
        } else if (this.toastBody?.toastType.toLowerCase() === 'warn') {
            assignedClass = 'toast-body-warn';
        } else if (this.toastBody?.toastType.toLowerCase() === 'error') {
            assignedClass = 'toast-body-error';
        }
        return assignedClass;
    }

    // Returns the src attribute of the toast <img> element
    get toastImage(): string {
        let assignedImage: string = '';
        if (this.toastBody?.toastType.toLowerCase() === 'success') {
            assignedImage = 'assets/images/lottie/lottie-success.json';
        } else if (this.toastBody?.toastType.toLowerCase() === 'warn') {
            assignedImage = 'assets/images/lottie/lottie-warning.json';
        } else if (this.toastBody?.toastType.toLowerCase() === 'error') {
            assignedImage = 'assets/images/lottie/lottie-error.json';
        }
        return assignedImage;
    }
}
